import { render, staticRenderFns } from "./DistributionList.vue?vue&type=template&id=513ffe3e"
import script from "./DistributionList.js?vue&type=script&lang=js&external"
export * from "./DistributionList.js?vue&type=script&lang=js&external"
import style0 from "./DistributionList.vue?vue&type=style&index=0&id=513ffe3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports